import { Routes } from '@angular/router';
import { AuthGuard, RoleBasedGuard } from 'remarketing-angular-library';


export enum TransportationHubRoutePaths {
  TRANSPORTATION_INVENTORY_ITEM = ':inventoryItemUuid',
}

export const transportationHubRoutes: Routes = [
  {
    path: `transportation/${TransportationHubRoutePaths.TRANSPORTATION_INVENTORY_ITEM}`,
    loadComponent: () => import('./components/transportation-hub/transportation-hub.component').then(c => c.TransportationHubComponent),
    canActivate: [AuthGuard, RoleBasedGuard],
    data: {
      roles: ['View_Only']
    }
  },
];
